import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import { Button } from "./ui/button";
import { brand } from "../mock";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-lg bg-[#0B2447] flex items-center justify-center text-white group-hover:bg-[#122e5f] transition-colors">
            <ShieldCheck className="w-5 h-5" />
          </div>
          <div className="leading-tight">
            <div className="font-bold text-[15px] text-[#0B2447]">Brand Marketing</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Professionals</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive
                    ? "text-[#0B2447] bg-slate-100"
                    : "text-slate-600 hover:text-[#0B2447] hover:bg-slate-50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={brand.whatsapp} target="_blank" rel="noreferrer" className="text-sm text-slate-600 hover:text-[#0B2447]">Talk to us</a>
          <Link to="/contact">
            <Button className="bg-[#0B2447] hover:bg-[#122e5f] text-white rounded-md h-10 px-5">
              Free assessment
            </Button>
          </Link>
        </div>

        <button className="md:hidden p-2 text-slate-700" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium ${isActive ? "bg-slate-100 text-[#0B2447]" : "text-slate-700"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)}>
              <Button className="mt-2 w-full bg-[#0B2447] hover:bg-[#122e5f] text-white">Free assessment</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
